<template>
  <div>
    <b-collapse
      :open="defaultOpen"
      :aria-id="donnee.id"
      :animation="donnee.children && donnee.children.length ? 'slide' : ''">
      <template #trigger="props">
        <div
          :aria-controls="donnee.id"
          :aria-expanded="props.open"
          class="columns is-justify-content-space-between"
          role="button">
          <div class="column is-narrow pr-0 columns">
            <b-icon
              :class="{ 'is-invisible': !(donnee.children && donnee.children.length) }"
              :icon="props.open ? 'chevron-right' : 'chevron-down'"/>
            <a @click.stop>
              <b-checkbox v-model="donnee.selected" @input="$emit('check')"></b-checkbox>
            </a>
            <span class="" :class="classLibelle">
              {{ donnee.libelle }}
            </span>
          </div>
          <div class="column is-narrow pl-0">
            <a v-if="!(donnee.children && donnee.children.length)" @click="$emit('archive')">
              <b-icon icon="archive" type="is-default"/>
            </a>
          </div>
        </div>
      </template>
      <div class="card-content py-0 pr-0" v-if="donnee.children && donnee.children.length">
        <div class="content">
          <slot></slot>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  props: {
    donnee: {
      type: Object,
      required: true,
    },
    classLibelle: {
      type: String,
    },
    defaultOpen: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
